import React from 'react';
import { useIntl } from 'react-intl';

import { Typography } from 'app/shared/components/atoms';
import { Modal } from 'app/shared/components/molecules';

interface Props {
  isShowing: boolean;
  setIsShowing: React.Dispatch<React.SetStateAction<boolean>>;
  confirmationAction: () => void;
}

export const AdditionalPurchaseConfirmationModal: React.FC<
  React.PropsWithChildren<Props>
> = ({ isShowing, setIsShowing, confirmationAction }) => {
  const { formatMessage } = useIntl();

  const title = formatMessage({
    id: 'event.additionalPurchaseConfirmationModal.title',
  });
  const description = formatMessage({
    id: 'event.additionalPurchaseConfirmationModal.description',
  });
  const confirmationButtonText = formatMessage({
    id: 'event.additionalPurchaseConfirmationModal.confirmationButtonText',
  });
  const cancellationButtonText = formatMessage({
    id: 'event.additionalPurchaseConfirmationModal.cancellationButtonText',
  });

  return (
    <Modal
      data-qaid="additional-purchase-confirmation-modal"
      closeOnOutsideClick={true}
      isFullscreenMobile={false}
      isOpen={isShowing}
      setIsOpen={setIsShowing}
      title={title}
      primaryCtaText={confirmationButtonText}
      onClickPrimaryCta={() => {
        confirmationAction();
        setIsShowing(false);
      }}
      secondaryCtaText={cancellationButtonText}
      onClickSecondaryCta={() => setIsShowing(false)}
    >
      <Typography fontSize="fontSize100" fontWeight="regular">
        {description}
      </Typography>
    </Modal>
  );
};
